import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { IncomeTableSkeleton } from './components/IncomeTableSkeleton/IncomeTableSkeleton';

interface Props {
  title: string;
}

export const IncomeDetailsEmpty = ({ title }: Props) => {
  return (
    <IncomeTableSkeleton title={title}>
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    </IncomeTableSkeleton>
  );
};
